import { useDispatch, useSelector, } from 'react-redux'
import { useState, useEffect } from "react";
import { setRouterLength, setRoutes } from "../../../main/slices/routerSlice";

//---> Interfaces Generales;
import { SuccessStore } from "./screens/SuccessStore";
import { Error } from "./screens/Error";

//---> Interfaces POS;
import { SelectLogin } from "./screens/SelectLogin";
import {FormPAD} from "./screens/FormPAD"
import {QrPage} from "./screens/QrPage"
import {History} from "./screens/HistoryTransactions";

//---> Interfaces para retiro de Bancario;
import {FormWithdrawalBank} from "./screens/FormWithdrawalBank";
import {FormInfoUser} from "./screens/FormInfoUser";

//---> Interfaz perfil
import { SendOTP  } from "./screens/SendOtp";
import { ValUser} from "./screens/ValUserPos"
import { FormInfoStore } from "./screens/FormInfoStore";
import { StoresList } from "./screens/AllStoresUser"
import { UsersList } from "./screens/AllUsers"
import { Kyc } from "./screens/Kyc";
import { KYC } from "./screens/CheckKYC";

//---> Login con WLD;
import MiniKitProvider from "./WldApp";
import { LoginPos } from './screens/LoginPos';
import { FinalScreen } from './screens/FinalScreen';
import { TimeOut } from './screens/TimeOut';

export const ScreenRouter = () => {
    //---> Verifico si NO tengo los datos del usuario para logearlo;
    const user = useSelector((state) => state.user);

    // GET THE CURRENT SCREEN (THE screen const CHANGES WHEN THE state.router.value IS UPDATED ON THE routerSlice)
    const screen = useSelector(({ router }) => router);
    // const transactionState = useSelector(({ transaction }) => transaction);
    const dispatch = useDispatch();
    let cashStore = JSON.parse(process.env.REACT_APP_MOSTRAR_RETIRO_EFECTIVO_KIOSCOS);

    // MAP THE COMPONENTS INTO THE ROUTER
    const [routes] = useState([
        {   // 0
            next: null, last: -1,
            component: () => <SelectLogin />
        },
        {   // 1
            next: null, last: 0,
            component: () => <LoginPos />
        },

        //---> CREATE STORE
        {   // 2
            next: 3, last: 0,
            paths: ["email", "otp"], defaultPath: "email",
            component: (path) => <SendOTP  path={path} />,
        },
        
        //---> GET INFO USER
        {   // 3
            next: 4, last: 2,
            component: (path) => <FormInfoUser />
        },
        {   // 4
            next: 5, last: 3,
            component: (path) => <FormWithdrawalBank />
        },
        {   // 5
            next: 6, last: 4,
            component: (path) => <FormInfoStore />
        },
        {   // 6
            next: 0, last: 0,
            component: (path) => <SuccessStore />
        },

        //---> SESION WITH POS
        {   // 7
            next: -1, last: 1,
            paths: ["email", "otp"], defaultPath: "otp",
            component: (path) => <ValUser  path={path} />,
        },
        {   // 8
            next: -1, last: 1,
            paths: ["cash", "bank"], defaultPath: "cash",
            component: (path) => <FormPAD path={path}/>
        },
        {   // 9
            next: -1, last: 8,
            component: (path) => <QrPage />
        },
        {   // 10
            next: 11, last: 9,
            component: (path) => <FormWithdrawalBank />
        },
        {   // 11
            next: 0, last: 0,
            component: (path) => <History />,
        },

        //---> Final; Error, timeOut o Correcto;
        {   // 12
            next:0, last: 0,
            component: (path) => <FinalScreen />
        },
        {   // 13
            next: null, last: -1,
            component: () => <TimeOut />
        },

        //---> SESION WITH EMAIL
        {   // 14
            next: -1, last: 1,
            component: (path) => <StoresList />, //List stores
        },
        {   // 15
            next: -1, last: 1,
            component: (path) => <UsersList />, //List users (operators)
        },
    ]);

    // SET THE ROUTES AND ROUTES LENGTH JUST ONCE
    useEffect(() => {
        dispatch(setRouterLength({ length: routes.length }));
        dispatch(setRoutes(routes.map(r => ({ next: r.next, last: r.last }))));
    }, [routes, dispatch]);

    if(!user?.idWLD||!user?.token){ return  <MiniKitProvider />; }

    // RETURN THE SELECTED SCREEN BY FETCHING THE INDEX (screen) INTO THE STORE
    // IF A PATH IS PROVIDED AND EXISTS IT WILL BE SENT INTO THE SCREEN, OTHERWISE THE DEFUALT OR NULL WILL BE SENT
    const path = routes[screen.current]?.paths?.includes(screen.path) ? screen.path : routes[screen.current]?.defaultPath
    return routes[screen.current].component(path);
}